import React from 'react'

import {
  Avatar,
  Button,
  Checkbox,
  Loading,
  ModalBox,
  useModalContext,
} from '@fourthwall/components'
import { pluralize } from '@fourthwall/utils/dist/string'
import { useUsersQuery } from '@queries/useUsersQuery'

import * as S from './styled'

type Props = {
  selectedTeamStaff?: string[]
  onSave: (selectedTeamStaff: string[]) => void
}

export const SelectTeamStaff = ({ selectedTeamStaff, onSave }: Props) => {
  const modal = useModalContext()
  const [innerSelectedTeamStaff, setInnerSelectedTeamStaff] = React.useState<string[]>(
    selectedTeamStaff || [],
  )

  const { usersQuery } = useUsersQuery()

  const users = usersQuery.data?.users.filter((user) => user.invitationStatus === 'FULFILLED')

  return (
    <ModalBox
      title="Select team members"
      onClose={modal.close}
      footer={
        <>
          {innerSelectedTeamStaff.length} {pluralize(innerSelectedTeamStaff.length, 'member')}{' '}
          selected
        </>
      }
      buttons={[
        <Button label="Cancel" appearance="secondary" onClick={modal.close} />,
        <Button
          label="Save"
          appearance="primary"
          onClick={() => {
            onSave(innerSelectedTeamStaff)
            modal.close()
          }}
        />,
      ]}
    >
      <Loading isLoading={!users?.length}>
        <S.TableContainer id="scrollableDiv">
          {users?.map((user) => (
            <S.Container>
              <S.CheckboxContainer>
                <Checkbox
                  value={
                    !!innerSelectedTeamStaff.find((selectedMember) => selectedMember === user.email)
                  }
                  onValueChange={(value) => {
                    if (value) {
                      setInnerSelectedTeamStaff((prevSelectedMembers) => [
                        ...prevSelectedMembers,
                        user.email!,
                      ])
                    } else {
                      setInnerSelectedTeamStaff((prevSelectedMembers) =>
                        prevSelectedMembers.filter(
                          (prevSelecterMember) => prevSelecterMember !== user.email,
                        ),
                      )
                    }
                  }}
                />
              </S.CheckboxContainer>
              <Avatar name={user.fullName} size="small" />
              <S.Nickname>{user.fullName || user.email}</S.Nickname>
            </S.Container>
          ))}
        </S.TableContainer>
      </Loading>
    </ModalBox>
  )
}
